import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { tap, map } from "rxjs/operators";
import { HttpService } from "../HTTPService/HttpService";
import { BindingURLService } from "../Bindingurlservice/binding-url.service";
import { ApiService } from "../apiUrls/apiUrl.service";

@Injectable({
  providedIn: "root",
})
export class UserSettingDataService {
  private userSettingsSubject = new BehaviorSubject<any>(
    this.loadFromStorage(),
  );
  userSettings$ = this.userSettingsSubject.asObservable();

  constructor(
    private http: HttpService,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService,
  ) {}

  fetchUserSettings(): void {
    this.http
      .post(this.urlAuthentication.crudApiUrl + this.apiUrl.userSettingsUrl,{})
      .pipe(
        map((res) => {
          const resp = res.response[0];
          const [userDateFormat, userTimeFormat] =
            resp.DateTimeFormat.split(",");

          return {
            userDateFormat,
            userTimeFormat,
            userAlarmDisplayMd: resp.AlarmDisplayMode,
            userInitialMapZoom: resp.InitialMapZoomLevel,
            recordsPerPage: resp.RecordsPerPage,
            userRefreshInterval: resp.RefreshRate * 60000,
          };
        }),
        tap((settings) => {
          this.saveToStorage(settings);
          this.userSettingsSubject.next(settings);
        }),
      )
      .subscribe();
  }

  /** Get current user settings */
  getUserSettings(): Observable<any> {
    return this.userSettings$;
  }
  /** Save settings in localStorage */
  private saveToStorage(settings: any): void {
    localStorage.setItem("userSettings", JSON.stringify(settings));
  }

  /** Load settings from localStorage */
  private loadFromStorage(): any {
    const storedSettings = localStorage.getItem("userSettings");
    return storedSettings ? JSON.parse(storedSettings) : null;
  }
  /** Force refresh */
  refreshUserSettings(): void {
    this.fetchUserSettings();
  }
}
